import { render } from "./SectionGridCard.vue?vue&type=template&id=118d7ab4&scoped=true"
import script from "./SectionGridCard.vue?vue&type=script&lang=js"
export * from "./SectionGridCard.vue?vue&type=script&lang=js"

import "./SectionGridCard.vue?vue&type=style&index=0&id=118d7ab4&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118d7ab4"]])

export default __exports__